import { IconButton, InputAdornment, TextField } from '@mui/material';
import useDebounceSearch from 'hooks/useDebounceSearch';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { colors } from 'shared/colors';

const SearchInputNavbar = ({ inputKey, ...props }) => {
  const { t } = useTranslation();
  const [searchName, setSearchName] = useDebounceSearch(inputKey, '', 300);

  return (
    <TextField
      {...props}
      color='primary'
      variant='outlined'
      fullWidth
      id='search'
      name='search'
      placeholder={t('common.global.search')}
      autoComplete='off'
      className='max-w-none'
      value={searchName}
      onInput={(event) => setSearchName(event.target?.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position='start'
            className='custom-startAdornment ml-[8px]'
          >
            {searchName ? (
              <IconButton onClick={() => setSearchName('')} variant='onlyIcon'>
                <i className='bi bi-x end-adornment-close-button' />
              </IconButton>
            ) : (
              <IconButton variant='onlyIcon' disabled disableRipple>
                <i className='bi bi-search text-base leading-4' />
              </IconButton>
            )}
          </InputAdornment>
        ),
        sx: {
          borderColor: '#E5E9EB',
          outlineColor: '#E5E9EB',
          height: '45px',
        },
      }}
      sx={{
        '& .MuiOutlinedInput-root.Mui-focused i': {
          color: colors.baseColor,
        },
        '& .MuiOutlinedInput-root i': {
          color: colors.grayColor,
        },
        '& fieldset': {
          borderColor: '#E5E9EB',
        },
        background: 'white',
        borderRadius: '10px',
      }}
    />
  );
};

export default SearchInputNavbar;
